<template>
  <div class="popup-background">
    <div class="popup-body">
      <component :is="$store.state.popup.component"></component>
    </div>
  </div>
</template>

<script>
import accountType from '@/components/Settings/AccountType'
import language from '@/components/Settings/Language'
import birthDay from '@/components/Settings/BirthDay'
import userCountry from '@/components/Settings/Country'
import userPrefecture from '@/components/Settings/Prefecture'
import userAddress from '@/components/Settings/Address'
import messageShow from '@/components/Message/Show'

export default {
  components: {
    accountType,
    language,
    birthDay,
    userCountry,
    userPrefecture,
    userAddress,
    messageShow
  }
}
</script>

<style lang="scss" scoped>
.popup {
  &-background {
    position: fixed;
    height: 100vh;
    width: 100vw;
    z-index: 100;
    background-color: rgba(0, 0, 0, 0.4);

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &-body {
    width: 80%;
    height: 300px;
    background: white;
  }
}
</style>
